import React from "react";
import { useTranslation } from "react-i18next";
import "../SchedulingStyles/BookingModal.css";
import FormatUrl from "../../../utils/UrlFormatter";
import { toast } from "react-toastify";

const BookingModal = ({ show, onClose, onConfirm, details }) => {
  const { t } = useTranslation();

  if (!show) return null;

  const {
    patient,
    discipline,
    practitioner,
    date,
    slots = [],
    breakEnabled,
    breakSlot,
    clinicId,
    csrfToken,
    appointmentFee,
    isRegistered,
  } = details;

  const slotIds = slots.map((s) => s.id);
  const slotRange =
    slotIds.length > 0
      ? breakEnabled && breakSlot
        ? `${slotIds.join("-")}-b${breakSlot.id}`
        : slotIds.join("-")
      : "";

  const handleConfirm = async () => {
    try {
      const url = FormatUrl("/create-slot/");
      const formData = new FormData();
      formData.append("clinic_id", clinicId);
      formData.append("patient_id", patient?.id);
      formData.append("practitioner_id", practitioner?.id);
      formData.append("slot_id", slotRange);
      formData.append("appointment_fee", appointmentFee || "0");
      formData.append("medical_history", "");
      formData.append("current_medications", "");
      formData.append("allergies", "");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRFToken": csrfToken,
        },
        body: formData,
        credentials: "include",
      });

      const data = await response.json();
      if (data.status === "failure" || response.status !== 200) {
        toast.error(t("admin_scheduling_new.booking_failed"));
      } else {
        toast.success(t("admin_scheduling_new.booking_success"));
        onConfirm();
      }
    } catch (error) {
      console.error("Error creating appointment:", error);
      toast.error(t("admin_scheduling_new.booking_error"));
    }
  };

  return (
    <div className="ad-sched-modal-overlay">
      <div className="ad-sched-modal-content">
        <h3>{t("admin_scheduling_new.confirm_booking_title")}</h3>
        <div className="ad-sched-booking-summary">
          <div className="label-value-pair">
            <strong>{t("admin_scheduling_new.label_patient")}</strong>
            <span>{patient?.name}</span>
          </div>
          <div className="label-value-pair">
            <strong>{t("admin_scheduling_new.label_discipline")}</strong>
            <span>{discipline}</span>
          </div>
          <div className="label-value-pair">
            <strong>{t("admin_scheduling_new.label_practitioner")}</strong>
            <span>{practitioner?.name}</span>
          </div>
          <div className="label-value-pair">
            <strong>{t("admin_scheduling_new.label_practitioner_type")}</strong>
            <span>
              {isRegistered
                ? t("admin_scheduling_new.registered_label")
                : t("admin_scheduling_new.not_registered_label")}
            </span>
          </div>
          <div className="label-value-pair">
            <strong>{t("admin_scheduling_new.label_date")}</strong>
            <span>{date}</span>
          </div>

          {slots.length > 0 && (
            <>
             {slots[0]?.raw?.station_number && (
                <div className="label-value-pair">
                  <strong>Room</strong>
                  <span className="room-highlight">{`Room ${slots[0].raw.station_number}`}</span>
                </div>
              )}
              <div className="label-value-pair">
                <strong>{t("admin_scheduling_new.label_selected_slots")}</strong>
              </div>
              <ul className="ad-sched-slot-list">
                {slots.map((slot) => (
                  <li key={slot.id}>{slot.label || `Slot ID: ${slot.id}`}</li>
                ))}
              </ul>
             


              {breakSlot && (
                <p className="ad-sched-break-slot">
                  <strong>{t("admin_scheduling_new.label_break_slot")}</strong>{" "}
                  {breakSlot.label}
                </p>
              )}

              <div className="label-value-pair">
                <strong>{t("admin_scheduling_new.label_appointment_fee")}</strong>
                <span>${Number(appointmentFee || 0).toFixed(2)}</span>
              </div>
            </>
          )}
        </div>

        <div className="ad-sched-modal-buttons">
          <button className="ad-sched-confirm-button" onClick={handleConfirm}>
            {t("admin_scheduling_new.btn_confirm")}
          </button>
          <button className="ad-sched-cancel-button" onClick={onClose}>
            {t("admin_scheduling_new.btn_cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
